import React, { useEffect } from "react";
import {useLocation, useNavigate} from "react-router-dom";
import i18n from "i18next";

const LanguageSync = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const match = location.pathname.match(/^\/(en|ru|hy)(\/|$)/);
        const urlLang = match?.[1];

        if (urlLang && i18n.language !== urlLang) {
            i18n.changeLanguage(urlLang);
        }
    }, [location.pathname]);

    return null;
};

export default LanguageSync;
